module.exports = __webpack_public_path__ + "img/lee_bastin.00d99ff8.jpg";